import React, { useEffect } from 'react';
import { Authenticator, useAuthenticator, View } from '@aws-amplify/ui-react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import '@aws-amplify/ui-react/styles.css';
import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';
import { CircularProgress, styled } from '@mui/material';
import { getUser } from '../requests';
I18n.putVocabularies(translations);

I18n.putVocabularies({
  ja: {
    'Reset Password': 'パスワードをリセット',
    'Enter your Username': 'ユーザー名を入力',
    'Enter your Password': 'パスワードを入力',
    'Incorrect username or password.': 'ユーザー名またはパスワードが違います',
    'Please confirm your Password': 'パスワードの確認',
  },
});

const Container = styled(View)`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Login = () => {
  const { i18n } = useTranslation();
  const { language } = i18n;
  const { route } = useAuthenticator(context => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  const [isReload, setIsReload] = React.useState(false);

  React.useEffect(() => {
    const checkUser = async () => {
      if (route === 'authenticated') {
        const user = await getUser();

        let from = '/prediction/map';
        if (!!user && typeof user === 'object' && 'name' in user) {
          from = location.state?.from?.pathname || '/prediction/map';
        } else {
          from = '/application';
        }

        navigate(from, { replace: true });
      }
    };

    checkUser();
  }, [route, navigate, location]);

  React.useEffect(() => {
    setIsReload(true);
    I18n.setLanguage(language);

    setTimeout(() => {
      setIsReload(false);
    }, 0);
  }, [language]);

  return (
    <Container>
      {isReload ? null : (
        <Authenticator>
          <CircularProgress
            sx={{ position: 'fixed', top: '50%', left: 0, right: 0, margin: '0 auto' }}
            color="success"
          />
        </Authenticator>
      )}
    </Container>
  );
};

export default Login;
